import { GET_LICENCE_SCOPES_ENDPOINT, GET_SUB_SCOPES_ENDPOINT } from '../service/backend_endpoints/_endpointPaths'
import { apiService } from '../service/api.service'
const GET_LICENCE_SCOPES = 'getLicenceScopes'
const GET_SUB_SCOPES = 'getSubScopes'

const state = {
  getLicenceScopes: [],
  subScopes: [],
  loadingSubScopes: false,
  loadingScopes: true
}

const getters = {
  getLicenceScopes: state => state.getLicenceScopes,
  getSubScopes: state => state.subScopes,
  loadingScopes (state) {
    return state.loadingScopes
  },
  loadingSubScopes (state) {
    return state.loadingSubScopes
  }
}

const actions = {
  async [GET_LICENCE_SCOPES] (context) {
    context.commit('setLicenceScopeLoading', true)
    try {
      const { data } = await apiService.get(GET_LICENCE_SCOPES_ENDPOINT)
      context.commit(GET_LICENCE_SCOPES, data)
    } catch (error) {
      throw error.response
    } finally {
      context.commit('setLicenceScopeLoading', false)
    }
  },
  async [GET_SUB_SCOPES] (context, payload) {
    context.commit('setSubScopesLoading', true)
    try {
      const { data } = await apiService.get(`${GET_SUB_SCOPES_ENDPOINT}/${payload}`)
      context.commit(GET_SUB_SCOPES, data)
    } catch (error) {
      throw error.response
    } finally {
      context.commit('setSubScopesLoading', false)
    }
  }
}

const mutations = {
  [GET_LICENCE_SCOPES] (state, payload) {
    state.getLicenceScopes = payload.scopes
  },
  [GET_SUB_SCOPES] (state, payload) {
    state.subScopes = payload.subScopes
  },
  setLicenceScopeLoading (state, payload) {
    state.loadingScopes = payload
  },
  setSubScopesLoading (state, payload) {
    state.loadingSubScopes = payload
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
